import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import RightArrow from '../../assets/right-arrow.svg'
import CourseForm from './CourseForm';
import CourseOrderSummary from './CourseOrderSummary';
export default function TabPanel({setOnClose,setOpenModal}) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

   // Function to go to the next tab
   const handleNextTab = () => {
    setValue((prev) => (prev + 1));
  };


  // Custom Tab component with arrow
  const CustomTab = ({ label, isLast, ...props }) => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tab
        label={label}
        {...props}
        sx={{
          textTransform: 'none',
          fontSize: '1rem',
          padding: '12px 16px',
          fontFamily: theme=> theme.typography.smallText,
          minHeight: 'unset',
          '&.Mui-selected': {
            color: 'rgba(86, 4, 246, 1)',
            fontWeight: 'bold'
          }
        }}
      />
      {!isLast && (
        <img src={RightArrow} alt='Right Arrow'/>
      
      )}
    </Box>
  );

  // Custom TabPanel component
  function TabPanel({ children, value, index }) {
    return (
      <div hidden={value !== index} role="tabpanel">
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ border: '1px solid rgba(203, 177, 252, 1)', background:'rgba(203, 177, 252, 1)', borderRadius:'8px', mt: 3  }}>
        <Tabs 
          value={value} 
          onChange={handleChange}
          sx={{
            '& .MuiTabs-indicator': {
              display: 'none' // Hide the default indicator
            }
          }}
        >
          <CustomTab label="Order Summary" />
          <CustomTab label="Checkout"  isLast/>
          
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
      <Typography>Here’s a breakdown of your order. Review the details to ensure everything is just right before proceeding.</Typography>
      <CourseOrderSummary onClick={handleNextTab}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <Typography>Complete your payment securely and instantly to finalize your order. Your satisfaction is just a click away.</Typography>
      <CourseForm setOnClose={setOnClose} setOpenModal={setOpenModal}/>
      </TabPanel>
   
    </Box>
  );
}

